module.exports = __webpack_public_path__ + "static/backimage-leaf-5790f5aad478241b65599a5740776e45.svg";